import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";

import { BPostFieldAddress } from "../bpostAddressField.schema";

export const parseToBPostFieldAddress = (
    address: CloudCustomerAddress
): BPostFieldAddress => {
    const addressLine =
        (address.street &&
            address.number &&
            address.zipCode &&
            address.city &&
            `${address.street} ${address.number} ${
                address.box ? `${address.box}` : ""
            } ${address.zipCode} ${address.city}`) ||
        "";

    return {
        ...address,
        address: addressLine,
        selected: !!addressLine,
        isComplete: true
    };
};
